import { render, staticRenderFns } from "./dialog-collect-add.vue?vue&type=template&id=29da2852&scoped=true"
import script from "./dialog-collect-add.vue?vue&type=script&lang=js"
export * from "./dialog-collect-add.vue?vue&type=script&lang=js"
import style0 from "./dialog-collect-add.vue?vue&type=style&index=0&id=29da2852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29da2852",
  null
  
)

export default component.exports